export enum IllPersonStatus {
    ILL = "ILL",
    RECOVERED = "RECOVERED",
    CERTIFICATE_UPLOADED = "CERTIFICATE_UPLOADED",
    CERTIFICATE_LATE_SUBMIT = "CERTIFICATE_LATE_SUBMIT",
    CHECKED = "CHECKED",
    REJECTED = "REJECTED"
}